<template>
  <section class="wa-link">
    <h6>Atendimento pelo WhatsApp</h6>
    <p>Confirme o vínculo do seu WhatsApp com este usuário e o cliente selecionado no B2B.</p>
    <p>O número desta conversa deve estar preenchido em WhatsApp do usuário, no cadastro administrativo.</p>
    <p v-if="busy" role="status">Consultando…</p>
    <p v-if="error" role="alert" class="red-text">{{ error }}</p>
    <template v-if="status.enabled">
      <template v-if="status.vinculado">
        <p>WhatsApp vinculado: {{ status.telefone }}</p>
        <p>Cliente vinculado: {{ status.clienteId }}</p>
        <p v-if="cliente && String(cliente.clieId) !== String(status.clienteId)">O cliente selecionado mudou. Para consultar este cliente pelo WhatsApp, desvincule e confirme um novo código.</p>
        <button type="button" :disabled="busy" @click="unlink">Desvincular WhatsApp</button>
      </template>
      <form v-else @submit.prevent="link">
        <p>Envie VINCULAR ao número de teste da empresa. Cole abaixo o código recebido nessa conversa. Ele vale por 10 minutos.</p>
        <label for="wa-link-code">Código recebido no WhatsApp</label>
        <input id="wa-link-code" v-model.trim="code" maxlength="32" autocomplete="off" :disabled="busy">
        <p v-if="cliente">O vínculo será para {{ cliente.clieNome }}.</p>
        <button type="submit" :disabled="busy || !validCode">Confirmar vínculo</button>
      </form>
      <p>Após confirmar, envie MENU ao WhatsApp. As consultas seguem suas permissões de cliente e carteira no B2B; os orçamentos usam o cliente vinculado. Para cotar, envie ORÇAMENTO e a lista de códigos e quantidades.</p>
    </template>
    <p v-else-if="!busy">O piloto de WhatsApp ainda não está disponível neste ambiente. A empresa precisa configurar o número de teste e autorizar os participantes.</p>
  </section>
</template>
<script>
export default {
  props: { cliente: Object },
  data() { return { status: {}, code: '', busy: false, error: null, active: true }; },
  computed: { validCode() { return /^[A-Za-z0-9_-]{32}$/.test(this.code); } },
  created() { this.load(); },
  beforeDestroy() { this.active = false; this.code = ''; },
  methods: {
    load() { this.busy = true;
      return this.$http.get('chat/whatsapp/vinculo').then(r => { if (this.active) this.status = r.body; })
        .catch(() => { if (this.active) this.error = 'Não foi possível consultar o vínculo. Confira a liberação do chat e sua sessão.'; })
        .then(() => { if (this.active) this.busy = false; });
    },
    link() { if (this.busy || !this.validCode) return; this.busy = true; this.error = null;
      return this.$http.post('chat/whatsapp/vinculo', { codigo: this.code }).then(r => {
        if (this.active) { this.status = Object.assign({ enabled: true }, r.body); this.code = ''; }
      }).catch(r => { if (this.active) this.error = r.body && r.body.error || 'Não foi possível confirmar o vínculo.'; })
        .then(() => { if (this.active) this.busy = false; });
    },
    unlink() { if (this.busy) return; this.busy = true; this.error = null;
      return this.$http.delete('chat/whatsapp/vinculo').then(() => { if (this.active) this.status = { enabled: true, vinculado: false }; })
        .catch(() => { if (this.active) this.error = 'Não foi possível desvincular. Tente novamente.'; })
        .then(() => { if (this.active) this.busy = false; });
    }
  }
};
</script>
<style scoped>
.wa-link p { font-size: 13px; line-height: 1.5; }
.wa-link button { padding: 9px 12px; border: 1px solid #9cb9a8; border-radius: 5px; background: #eef5f1; color: #1b5e39; cursor: pointer; }
.wa-link input { box-sizing: border-box; }
</style>



// WEBPACK FOOTER //
// ChatWhatsAppPanel.vue?23f660ec